module.exports = __webpack_public_path__ + "static/media/75508671-5A76-4975-8C8A-5029CB7F1B9D.324d8470.jpeg";